//
//
//
//

import wx from "weixin-js-sdk";
export default {
  name: '',
  data () {
    return {
      msg: '授权页面，授权完后跳转小程序'
    }
  },
  created() {
    const self = this
    const orderId = this.$route.query.orderId
    console.log(orderId)
    wx.miniProgram.redirectTo({
        url:"/pages/orderList/orderDetail?orderId=" + orderId + "&hasOauth=true",
        fail: () =>  {
            self.$vux.toast.text('退出小程序重新进入即可领取红包')
        }
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/auth.vue